export default __webpack_public_path__ + "static/vialactea-0c45318b8d725845e0a3ce5a183c7b99.jpg";